import React from 'react';

export const SidebarContext = React.createContext({
  isOpen: false,
  toggle: () => {},
  hasSidebar: false,
  setHasSidebar: (_: boolean) => {},
});
